'use strict';

angular.module('webAgro1App').factory('CommonHTTPService', function() {
  return {
    isTimeout: function(status) {
      return status <= 0 || status === 408;
    },

    isForbidden: function(status) {
      return status === 403;
    },

    isSuccess: function(status) {
      return 200 <= status && status < 300;
    },

    isUnauthorized: function(status) {
      return status === 401;
    },

    isNotFound: function(status) {
      return status === 404;
    },

    isBadRequest: function(status) {
      return status === 400;
    },

    isLocked: function(status) {
      return status === 423;
    },

    isAccept: function(status) {
      return status === 202;
    }
  };
});
